module.exports = __webpack_public_path__ + "static/media/webSchema1.cbd1e783.png";